export const CONTRACTORS_MODAL_STEPS = {
  GENERAL: 1,
  WORKS: 2,
  TENDERS: 3,
  NOTES: 4,
};
